import { useStaticQuery, graphql } from 'gatsby'

export function useDataFirstScreenByHy() {
    const data = useStaticQuery(graphql`
        {
            mainVideo: datoCmsRenshinMainVideo(locale: { eq: "hy" }) {
                videoDesktop {
                    url
                    video {
                        mp4Url(res: high)
                        thumbnailUrl(format: jpg)
                    }
                }

                videoMobile {
                    url
                    video {
                        mp4Url(res: medium)
                        thumbnailUrl(format: jpg)
                    }
                }

                posterDesktop {
                    url
                }

                posterMobile {
                    url
                }
            }
        }
    `)

    return data.mainVideo
}
